/**
 * Format DateTime based on Intl.DateTimeFormat
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 *
 * @param {string | null | undefined} value - ISO date string or date-like string.
 * @param {Intl.DateTimeFormatOptions} options - Intl.DateTimeFormat configuration options.
 * @param {string} locale - Locale string (e.g., 'en-US', 'uk-UA').
 *
 * @returns {string | null} Formatted date string or null if input is invalid.
 */
export default function formatDate(
    value: string | null | undefined,
    options: Intl.DateTimeFormatOptions = {
        month:  'long',
        day:    'numeric',
        year:   'numeric',
        hour:   'numeric',
        minute: 'numeric',
    },
    locale: string = 'en-US',
): string | null {
    if (!value) return null;

    try {
        // Fix for older ISO formats to ensure proper Date parsing
        const normalizedDate = new Date(value.replace(/\+([0-9]{2})([0-9]{2})/g, '+$1:$2'));

        // Check if date is valid
        if (isNaN(normalizedDate.getTime())) return null;

        return new Intl.DateTimeFormat(locale, options).format(normalizedDate);
    } catch {
        return null;
    }
}
